export enum QuoteType {
  Urgency = "Urgency",
  TimeSlot = "TimeSlot",
  TimeSlotPerTask = "TimeSlotPerTask",
  DynamicTimeSlot = "DynamicTimeSlot",
  FreeStyle = "FreeStyle",
  PerTask = "PerTask"
}
